import withAsyncRouteLoading from "UIComponents/AsyncRouteLoadingHoc";
import { setSubChildId } from "Administrator/modules/AdministratorModule";

export default store => ({
  path: "standard-calculation",
  component: withAsyncRouteLoading(
    () =>
      Promise.all([
        import(/* webpackChunkName: "admin-academicSetup" */ "./components"),
      ]).then(([importedModule0]) => {
        const component = importedModule0.default;
        return component;
      })
    //.catch(err => {
    //   throw err;
    // })
  ),
  onEnter() {
    store.dispatch(setSubChildId("STANDARD_CALCULATION"));
  },
  onLeave() {
    store.dispatch(setSubChildId(""));
  },
});
